import { render, staticRenderFns } from "./BarChartSource.vue?vue&type=template&id=064f3218&"
import script from "./BarChartSource.vue?vue&type=script&lang=js&"
export * from "./BarChartSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports